import axios from 'axios';
import { ProjectDetailsDTO, TaskDTO, TaskFilterParams } from '../types/client.types';
import { ApplyLeaveDto, LeaveBalanceDto, LeaveHistoryDto } from '../services/leaveModels';
// eslint-disable-next-line
const baseURLs: string = process.env.REACT_APP_API_ENDPOINT as string;

// export const baseURLLocal = 'https://localhost:7103/';  
//93.127.199.247
export const baseURLLocal = 'https://api.appspro.in:443/';            //Live
// export const baseURLLocal = 'https://93.127.199.247:443/';

export const loginApi = async (email: string, password: string) => {
  const res = await axios.post(`${baseURLLocal}api/Auth/login`, {
    email, password
  });
  return res.data;
};

const API = axios.create({
  baseURL: baseURLLocal,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});


//#region Admin API

export interface CreateUserDTO {
  name: string;
  email: string;
  password: string;
  role: string;
  department: string;
  gender: string;
  phoneNumber: string;
}

export interface ProjectDTO {
  id: number;
  projectID: string;
  projectName: string;
  description: string;
  createdById: string;
  createdByName: string;
  teamLeadIds: string[];
  teamLeadNames: string[];
  startDate: string;
  endDate: string;
  status: string;
  remarks: string;
  taskCount: number;
  percentCompleted: number;
}

// Create user
export const createNewUser = (data: CreateUserDTO) => API.post('api/Auth/register', data);

// Get user by ID
export const getUserById = (id: string) => API.get(`api/Admin/getuser/${id}`);

// Update user
export const updateUser = (id: string, data: {
  name: string;
  email: string;
  role: string;
  department:string;
  gender:string;
  phoneNumber:string;
}) => API.put(`api/Admin/updateuser/${id}`, data);

// Delete user
export const deleteUser = (id: string) => API.delete(`api/Admin/deleteuser/${id}`);

// Get all users
export const getAllUsers = () => API.get('api/Admin/getusers');

// Get all projects
export const getAllProjects = () => API.get('api/Admin/getprojects');

// Get project by ID
export const getProject = (id: string) => API.get(`api/Admin/getproject/${id}`);

// Get all tasks
export const getAllTask = () => API.get('api/Admin/gettasks');

// Get all subtasks
export const getAllSubTask = () => API.get('api/Admin/getsubtasks');

//#endregion Admin API

//#region PM API

export const createNewProject = (data: {
  ProjectID: string;
  ProjectName: string;
  Description: string;
  TeamLeadIds: string[];
  StartDate?: string;
  EndDate?: string;
  Status: string;
  Remarks: string;
}) => API.post('api/Project/createproject', data);


export const getMyProjects = () => API.get('api/Project/getprojects');

export const getTeamLeads = () => API.get('api/Project/teamleads');

export const getprojectByID = (id: string) => API.get(`api/Project/getprojects/${id}`);

export const getProjectDetails = (id: string) => API.get(`api/Project/project-details/${id}`);
export const updateProject = (id: string, data: {
  ProjectID: string;
  ProjectName: string;
  Description: string;
  TeamLeadIds: string[];
  StartDate: string;
  EndDate: string;
  Status: string;
  Remarks: string;
}) => API.put(`api/Project/updateproject/${id}`, data);
export const deleteProject = (id: string) => API.delete(`api/Project/deleteproject/${id}`);
export const GetUsers = () => API.get('api/Project/getUsers');

export const updateTaskVisibility = (taskId: number, isVisible: boolean) =>
  API.put(`api/Project/task/${taskId}`, { isVisible });

export const updateSubTaskVisibility = (subTaskId: number, isVisible: boolean) =>
  API.put(`/api/Project/subtask/${subTaskId}`, { isVisible });


//#endregion PM API

//#region TeamLead API

// Interfaces for DTOs
export interface TaskCreateDto {
  description: string;
  projectId: number;
  assignedToId: string;
  dueDate: string | null;
 completionDate?: string | null;
  status: string;
  priority: string;
  percentCompleted: number;
  remarks: string;
  issues: string;
  subTasks?: {
    description: string;
    assignedToId: string;
    dueDate: string;
    priority: string;
    status: string;
    workHours: number;
    completionDate?: string;
    issues: string;
    remarks: string;
  }[];
}

export interface TaskUpdateDto {
  title: string;
  assignedToId: string;
  dueDate: string;
    completionDate?: string;

  status: string;
  priority: string;
  percentCompleted: number;
  qcProgress:number;

  remarks: string;
  subTasks: SubTaskDto[];
}
interface SubTaskDto {
  id?: number;
  title: string;
  assignedToId: string;
  dueDate: string;
  status: string;
  workHours?: number;
  completionDate?: string | null;
  remarks?: string;
}
// eslint-disable-next-line
interface SubTaskCreateDto {
  title: string;
  taskId: number;
  assignedToId: string;
  dueDate: string;
  status: string;
  workHours: number;
  completionDate?: string;
  remarks: string;
}

export interface SubTaskUpdateDto {
  description: string; // Changed from title
  assignedToId: string;
  status: string;
  priority: string; // Added
  percentCompleted: number; // Added
  workHours: number;
  completionDate?: string | null;
  remarks: string;
  issues: string; // Added
  parentSubTaskId: number | null; // Added
}

// TeamLead API Endpoints
export const getTeamLeadProjects = () => API.get('api/TeamLead/projects');

export const getTLProjectDetails = (id: string) => API.get(`api/TeamLead/project-details/${id}`);

export const createTask = (data: TaskCreateDto) => API.post('api/TeamLead/tasks', data);

export const getCreatedTask = () => API.get('api/TeamLead/my-tasks');

export const getTaskById = (id: number) => API.get(`api/TeamLead/tasks/${id}`);

export const updateTask = (id: number, data: any) => API.put(`api/TeamLead/tasks/${id}`, data);

export const deleteTask = (id: number) => API.delete(`api/TeamLead/tasks/${id}`);

export const createSubTask = (data: any) => API.post('api/TeamLead/subtasks', data);

export const getSubTaskById = (id: number) => API.get(`api/TeamLead/subtasks/${id}`);

export const updateSubTask = (id: number, data: SubTaskUpdateDto) => API.put(`api/TeamLead/subtasks/${id}`, data);

export const deleteSubTask = (id: number) => API.delete(`api/TeamLead/subtasks/${id}`);

export const getTeammember = () => API.get('api/TeamLead/team-members');

//#endregion TeamLead API

//#region TeamMember API
// interfaces.ts
export interface SubTaskList {
  id: number;
  title?: string; // normalized from description
  description: string;
  assignedToName?: string;
  createdByName?: string;
  dueDate: string;
  status: string;
  workHours?: number;
  completionDate?: string;
  remarks?: string;
  issues?:string;
  priority?:string;
  percentCompleted?:number;
canEdit:boolean;
spentHours?: number;
  maxHours?: number;
}

export interface TaskList {
  id: number;
  projectName: string; // changed from number to string
  description?: string;
  assignedToId?: string;
  dueDate: string;
    completionDate?: string;

  status: string;
  createdByName: string;
  assignedToName: string;
  percentCompleted?: number;
  remarks?: string;
  issues?:string;
  subTasks?: SubTaskList[];
  priority?:string;
  spentHours?: number;
  maxHours?: number;

}


export const getMyTasks = async (): Promise<TaskList[] | { $values: TaskList[] }> => {
  const response = await API.get("api/TeamMember/tasks");
  return response.data;
};

export const updateMyTask = async (id: number, updatedTask: Partial<TaskList>): Promise<void> => {
  await API.put(`api/TeamMember/tasks/${id}`, updatedTask);
};

export const updateMySubTask = async (
  id: number,
  updatedSubTask: Partial<SubTaskList>
): Promise<void> => {
  await API.put(`api/TeamMember/subtasks/${id}`, updatedSubTask);
};

// -------------------------------------------------------------------------




// Get Team Leads ([GET] api/TeamMember/teamleads)
export const getTeamLeadsForMember = () => API.get('api/TeamMember/teamleads');

//#endregion TeamMember API

//#region UserProfile API


export interface UserProfileDTO {
  userID:string;
  name: string;
  email: string;
  role: string;
  department: string;
  gender: string;
  phoneNumber: string;
}

export interface ChangePasswordDTO {
  currentPassword: string;
  newPassword: string;
}

// Get current user profile ([GET] api/UserProfile)
export const getUserProfile = () => API.get<UserProfileDTO>('api/UserProfile');

// Change password ([PUT] api/UserProfile/change-password)
export const changePassword = (data: ChangePasswordDTO) =>
  API.put('api/UserProfile/change-password', data);

//#endregion UserProfile API

export interface ResetDTO{
email:string;
newPassword:string;
}

export const resetPassword=(data:ResetDTO)=>API.post('api/Admin/resetpassword',data);

export interface CreateTimeSheetDTO {
  date: string;  // YYYY-MM-DD
  projectName: string;  // Now string
  module?: string;
  product?: string;
  part?: string;
  hours: number;
  description?:string | null;
  assignedBy: string;
  draftingType?: string | null;
  quantity?: number | null;
  totPages?: number | null;
  taskDescription?: string;
  subTask?: string |null;
  childSubTask?: string |null;
  createdByName?:string;
}

export interface TimeSheetResponseDTO {
  timeId: string;
  userName: string;
  userDepartment: string;
  date: string;  // YYYY-MM-DD
  projectName: string;
  module?: string;
  product?: string;
  part?: string;
  description?:string;
  hours: number;
  assignedBy: string;
  createdAt: string;
  updatedAt?: string;
  draftingType?: string | null;
  quantity?: number | null;
  totPages?: number | null;
  spentHours?: number;
  subTask?: string |null;
  childSubTask?: string |null;
}

export interface ProjectOption {
  id: number;
  projectName: string;
}

// User role for admin checks
export interface UserProfile {
  role: string;  // e.g., "Admin"
}


//#region TimeSheet API

// Create timesheet ([POST] api/UserProfile/timesheet)
export const createTimeSheet = (data: CreateTimeSheetDTO) => API.post<TimeSheetResponseDTO>('api/UserProfile/timesheet', data);

// Get all timesheets ([GET] api/UserProfile/timesheets) with optional filters
export const getAllTimeSheets = (
  startDate?: string,
  endDate?: string,
  projectName?: string,
  selectedUser?: string
): Promise<TimeSheetResponseDTO[]> => {
  const params = new URLSearchParams();

  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (projectName) params.append('projectName', projectName);
  if (selectedUser && selectedUser !== 'All') params.append('userId', selectedUser);

  const url = `api/UserProfile/timesheets${params.toString() ? `?${params.toString()}` : ''}`;

  return API.get<TimeSheetResponseDTO[]>(url).then(res => res.data);
};
export const getNotFilledTimeSheets = (
  startDate: string,
  endDate: string,
  projectName?: string,
  userId?: string
) => {
  return API.get("api/UserProfile/timesheets/not-filled", {
    params: {
      startDate,
      endDate,
      projectName,
      userId
    }
  });
};


// Update timesheet ([PUT] api/UserProfile/timesheets/{timeId}) - Admin only
export const updateTimeSheet = (timeId: string, data: CreateTimeSheetDTO) => API.put<TimeSheetResponseDTO>(`api/UserProfile/timesheets/${timeId}`, data);

// Delete timesheet ([DELETE] api/UserProfile/timesheets/{timeId}) - Admin only
export const deleteTimeSheet = (timeId: string) => API.delete(`api/UserProfile/timesheets/${timeId}`);

// Get projects for dropdown ([GET] api/Admin/getprojects) - Reuse existing
export const getProjects = (): Promise<ProjectDTO[]> => getAllProjects().then(res => res.data);  // Map to ProjectOption if needed in component

// Get project names only (new endpoint)
export const getProjectNames = (): Promise<string[]> => 
  API.get<string[]>('api/UserProfile/ProjectName').then(res => res.data);  // Adjust route if controller name differs (e.g., 'api/ProjectNames')
//#endregion TimeSheet API

//#region AuditLogs

export interface AuditLogDTO {
  id: number;
  userId: string;
  userName: string;
  action: string;
  entity: string;
  entityId: string;
  timestamp: string;
  details: string;
  oldValue?: string;
  newValue?: string;
}

// NEW: Get all audit logs with filters
export const getAllAuditLogs = (
  entity?: string,
  entityId?: string,
  startDate?: string,
  endDate?: string,
  userId?: string
): Promise<AuditLogDTO[]> => {
  const params = new URLSearchParams();
  if (entity) params.append('entity', entity);
  if (entityId) params.append('entityId', entityId);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (userId) params.append('userId', userId);

  const url = `api/Admin/auditlogs${params.toString() ? `?${params.toString()}` : ''}`;
  return API.get<AuditLogDTO[]>(url).then(res => res.data);
};

// NEW: Get audit logs for specific task
export const getTaskAuditLogs = (taskId: number): Promise<AuditLogDTO[]> =>
  API.get<AuditLogDTO[]>(`api/Admin/auditlogs/task/${taskId}`).then(res => res.data);

// NEW: Get audit logs for specific subtask
export const getSubTaskAuditLogs = (subTaskId: number): Promise<AuditLogDTO[]> =>
  API.get<AuditLogDTO[]>(`api/Admin/auditlogs/subtask/${subTaskId}`).then(res => res.data);

//#endregion

//#region Comments API

export interface CommentDTO {
  id: number;
  content: string;
  projectId?: number;
  taskId?: number;
  subTaskId?: number;
  createdAt: string;
  updatedAt?: string;
  createdById: string;
  createdByName?: string;
  isDeleted?:string;
  isEdited?:string;
  isRead?:boolean;
}

// ✅ Get comments for project/task/subtask
export const getComments = (
  entityType: "project" | "task" | "subtask" |"childSubTask",
  entityId: number
) =>
  API.get<CommentDTO[]>(`api/Comments/${entityType}/${entityId}`).then(
    (res) => res.data
  );

// ✅ Add a comment (matches CommentCreateDTO)
export const addComment = (data: {
  entityType: "Project" | "Task" | "SubTask"|"childSubTask";
  entityId: number;
  content: string;
}) => API.post("api/Comments", data).then((res) => res.data);

// ✅ Edit a comment
export const editComment = (id: number, content: string) =>
  API.put(`api/Comments/${id}`, { content });

// ✅ Delete a comment
export const deleteComment = (id: number) =>
  API.delete(`api/Comments/${id}`).then((res) => res.data);
export const getUnreadCount = (
  entityType: "project" | "task" | "subtask" |"childSubTask",
  entityId: number
) => 
  API.get<{ unreadCount: number }>(
    `api/Comments/unread-count/${entityType}/${entityId}`
  ).then(res => res.data.unreadCount);


export const getTeammemberMention = () => API.get('api/Comments/team-members');

//#endregion

// OverallLogDTO returned by backend
export interface OverallLogDTO {
  id: number;
  entityType: string;
  entityId: number;
  fieldName: string;
  oldValue?: string;
  newValue?: string;
  action: string;
  logTime: string;
  userId: string;
  userName: string;
}

export const getOverallLogs = (params?: {
  entityType?: string;
  entityId?: number;
  userId?: string;
  action?: string;
  from?: string;
  to?: string;
}) =>
  API.get("api/OverallLog", { params });


// GET logs by project
export const getProjectLogs = (projectId: number) =>
  API.get<OverallLogDTO[]>(`api/OverallLog/project/${projectId}`).then(
    (res) => res.data
  );

// GET logs by task
export const getTaskLogs = (taskId: number) =>
  API.get<OverallLogDTO[]>(`api/OverallLog/task/${taskId}`).then(
    (res) => res.data
  );

// GET logs by subtask
export const getSubTaskLogs = (subTaskId: number) =>
  API.get<OverallLogDTO[]>(`api/OverallLog/subtask/${subTaskId}`).then(
    (res) => res.data
  );
  
export const getChildSubTaskLogs = (childSubTaskId: number) =>
  API.get<OverallLogDTO[]>(`api/OverallLog/child-subtasks/${childSubTaskId}`).then(
    (res) => res.data
  );




  //#region Client
export const getClientProjects = () =>
  API.get<ProjectDTO[]>("api/client/projects");

export const getClientProjectDetails = (projectId: number) =>
  API.get<ProjectDetailsDTO>(`api/client/projects/${projectId}`);

// ================= FILTER =================

export const filterTasks = (params: TaskFilterParams) =>
  API.get<TaskDTO[]>("api/client/projects/filter", { params });

// ================= LOCKING =================

export const lockTask = (taskId: number, lock: boolean) =>
  API.put(`api/client/tasks/${taskId}/due-date-lock`, { lock });

export const lockSubTask = (subTaskId: number, lock: boolean) =>
  API.put(`api/client/subtasks/${subTaskId}/due-date-lock`, { lock });


export const lockChildSubTask = (childSubTaskId: number, lock: boolean) =>
  API.put(`api/client/child-subtasks/${childSubTaskId}/due-date-lock`, { lock });



  //#endregion

  export const getDueDateLockStatus = (
  type: "task" | "subtask" ,
  id: number
) => {
  return API.get("api/TeamLead/due-date-lock-status", {
    params: { type, id },
  });
};

export const createClientInput = (payload: {
  message: string;
  taskId?: number;
  subTaskId?: number;
}) =>
  API.post("api/ClientInput/client-input", payload);


export const replyClientInput = (payload: {
  clientInputId: number;
  message: string;
}) =>
  API.post("api/ClientInput/client-input/reply", payload);


export const getClientInputs = (
  type: "task" | "subtask"|"childSubTask" ,
  id: number
) =>
  API.get("api/ClientInput/client-inputs", {
    params: { type, id },
  });

export const toggleTaskClientInput = (
  taskId: number,
  enabled: boolean
) => {
  return API.put(
    `api/ClientInput/tasks/${taskId}/client-input`,
    enabled   // ✅ raw boolean
  );
};

export const getTaskClientInput = (taskId: number) =>
  API.get(`api/ClientInput/tasks/${taskId}/client-input`);

export const getSubTaskClientInput = (subTaskId: number) =>
  API.get(`api/ClientInput/subtasks/${subTaskId}/client-input`);


export const toggleSubTaskClientInput = (
  subTaskId: number,
  enabled: boolean
) => {
  return API.put(
    `api/ClientInput/subtasks/${subTaskId}/client-input`,
    enabled   // ✅ raw boolean
  );
};
export const updateTaskMaxHours = (taskId: number, maxHours: number) =>
  API.put(`api/client/tasks/${taskId}/max-hours`, {
    maxHours,
  });
 
export const updateSubTaskMaxHours = (subTaskId: number, maxHours: number) =>
  API.put(`api/client/subtasks/${subTaskId}/max-hours`, {
    maxHours,
  });

  export const updateChildSubTaskMaxHours = (childSubTaskId: number, maxHours: number) =>
  API.put(`api/client/child-subtasks/${childSubTaskId}/max-hours`, {
    maxHours,
  });

export const updateTaskDueDate = (taskId: number, dueDate: string | null) =>
  API.put(`api/client/tasks/${taskId}/due-date`, {
    dueDate: dueDate
      ? new Date(dueDate + "T00:00:00").toISOString()
      : null
  });

export const updateSubTaskDueDate = (subTaskId: number, dueDate: string | null) =>
  API.put(`api/client/subtasks/${subTaskId}/due-date`, {
    dueDate: dueDate
      ? new Date(dueDate + "T00:00:00").toISOString()
      : null
  });

export const updateChildSubTaskDueDate = (childId: number, dueDate: string | null) =>
  API.put(`api/client/child-subtasks/${childId}/due-date`, {
    dueDate: dueDate
      ? new Date(dueDate + "T00:00:00").toISOString()
      : null
  });

export interface ChildSubTaskCreateDto {
  description: string;
  subTaskId: number;
  dueDate: string;
  priority?: string;
  status?: string;
  percentCompleted?: number;
  maxHours?: number;
  teamMemberIds: string[]; // GUIDs
}

export interface ChildSubTaskUpdateDto {
  description: string;
  priority: string;
  status: string;
  percentCompleted: number;
  maxHours?: number;
  spentHours?: number;
  completionDate?: string | null;
  remarks?: string;
  teamMemberIds: string[];
}

export interface ChildSubTaskViewDTO {
  id: number;
  subTaskId: number;

  description: string;

  maxHours?: number | null;
  spentHours?: number | null;

  dueDate: string;            // ISO string from API
  completionDate?: string | null;

  status: string;
  priority: string;

  percentCompleted: number;

  // 🔐 Assignment
  teamMemberIds: string[];    // Guid as string
  teamMemberNames: string[];

  // 🕒 Audit
  createdById: string;
  createdAt: string;

  updatedAt?: string | null;
  updatedById?: string | null;

  // 🔒 Flags
  isDueDateLocked: boolean;
  isClientInputEnabled: boolean;
}

export const createChildSubTask = (data: ChildSubTaskCreateDto) =>
  API.post("api/TeamLead/child-subtasks", data);

export const getChildSubTasksBySubTask = (subTaskId: number) =>
  API.get(`api/TeamLead/child-subtasks/${subTaskId}`);

export const getChildSubTaskById = (id: number) =>
  API.get(`api/TeamLead/child-subtasks/${id}`);


export const updateChildSubTask = (
  id: number,
  data: ChildSubTaskUpdateDto
) =>
  API.put(`api/TeamLead/child-subtasks/${id}`, data);


  export const deleteChildSubTask = (id: number) =>
  API.delete(`api/TeamLead/child-subtasks/${id}`);


  export interface ChildSubTaskUpdateTMDto {
  spentHours?: number;
  percentCompleted?: number;
  status?: string;
  remarks?: string;
  completionDate?: string | null;
}


export const getMyChildSubTasks = () =>
  API.get("api/TeamMember/child-subtasks");

export const getMyChildSubTaskById = (id: number) =>
  API.get(`api/TeamMember/child-subtasks/${id}`);

export const updateMyChildSubTask = (
  id: number,
  data: ChildSubTaskUpdateTMDto
) =>
  API.put(`api/TeamMember/child-subtasks/${id}`, data);

export const getCanCreate = async () => {
  const response = await API.get<boolean>("api/TaskSettings/can-create");
  return response.data;
};

export const updateCanCreate = async (value: boolean): Promise<void> => {
  await API.put("api/TaskSettings/can-create", value, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};


//#region Leave Balance API

export const getMyLeaveBalance = () =>
  API.get<LeaveBalanceDto[]>("api/Leave/my-balance");



export const applyLeave = (data: ApplyLeaveDto) =>
  API.post("api/Leave/apply", data);
export const getLeaveSummary = async (year: number) => {
  const response = await API.get(`api/AdminLeave/leave-summary?year=${year}`);
  return response.data;
};

export const getMyLeaveHistory = () =>
  API.get<LeaveHistoryDto[]>("api/Leave/my-history");

export const cancelLeave = (leaveId: number) =>
  API.delete(`api/Leave/cancel/${leaveId}`);

export const getHolidays = (year: number) =>
  API.get(`api/admin/holidays/${year}`);

export const getHolidaysByYear = (year: number) =>
  API.get<{ id: number; date: string; name: string }[]>(
    `api/admin/holidays?year=${year}`
  );
export const addHoliday = (data: { date: string; name: string }) =>
  API.post(`api/admin/holidays`, data);

export const deleteHoliday = (id: number) =>
  API.delete(`api/admin/holidays/${id}`);


export const getAllUserLeaves = (year?: number) =>
  API.get(`api/AdminLeave/leaves`, {
    params: year ? { year } : {},
  });

export const getUsers = () =>
  API.get(`api/AdminLeave/users`);
export const updateLeaveBalance = (data: {
  userId: string;
  leaveTypeId: number;
  year: number;
  newTotalDays: number;
}) =>
  API.put(`api/AdminLeave/update-balance`, data);

export const deleteLeave = (leaveId: number) =>
  API.delete(`api/AdminLeave/remove-leave/${leaveId}`);

export interface AdminLeave {
  leaveId: number;
  userId: string;
  userName: string;
  leaveType: string;
  fromDate: string;
  toDate: string;
  days: number;
  reason: string;
}
//#endregion Leave Balance API